<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        class="woom-bike-outline woom-original-3"
        viewBox="0 0 800 600"
        style="enable-background: new 0 0 800 600"
        xml:space="preserve"
        v-once>
        <g class="bike">
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M203.2,387.5c32.8-17.5,108.6-57.7,108.6-57.7l22.5,55.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M183.3,387.7c-9.8,5.5-16.5,9.2-17.5,9.7c-5.2,2.9-0.8,6,0.4,7.1c1.2,1.1,5.3,0.4,7.9,3.3s1.8,4,1.7,7.5
					s3.6,3.2,3.6,3.2l140.6,5.8l0.3-14c0,0-121.7-2.5-127-2.6c-5.3-0.1-11.8-8.5-4.6-12.5c1.4-0.8,6.7-3.6,14.5-7.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M388.3,406.7l151.2-148.4l0.7,5.2l1.8,3.2l28-10.5l-5.6-10.4l-20.6-51l-3.5-11.7l-27.6,11.5l0.8,2.1l2.5,4.3
					c0,0-129.7,69.4-139.5,74.6s-18.4,7.2-25.9,7.2c-7.5,0-37.2,0-37.2,0l-11.2-25.4l-16.2,6.5l21.3,54.9c0,0-86.1,47.9-124.1,69" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M371.9,447.7c-11.3,4.5-23.7,3.8-23.7,3.8l-179.1-13.1c0,0-30.3-1-28.5-26.7c1.7-22.9,23.9-23.6,23.9-23.6
					s7.1-0.1,18.6-0.2" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M203.2,387.5c53.7-0.7,144.5-1.8,146.6-1.8c3,0,39.4-3.9,40.7,33.6c0.2,5.8-0.8,10.5-2.7,14.4" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M381.3,456c-12.7-11.3-32.4-28.7-32.4-28.7s-10.6-9.6,0.1-19.2c8.7-7.8,17.6,1.7,17.6,1.7l40.8,46" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M407.7,468.9c-3.6,3.6-8.4,2-12.1-0.4" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M370.1,388.2l158.8-156.2l-5.3-14.1c0,0-139.2,71.8-144.5,74.4s-12.3,6.7-25.2,6.7
					c-12.9,0.1-34.2,0.2-34.2,0.2l34.9,86.4" />
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="553.8,289.4 551.3,289 542.1,266.7 570.1,256.2 578.1,277.8 577.5,279.2" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M594.6,315.4c5.4,10.8,9.7,19.4,9.7,19.4l25.5,56.3l-15.3,7.7l-1.1,0.6l-39.1-70l-23-46.9
					c0,0,0.6-7.9,8.6-11.2c6.6-2.8,12.2-0.4,13.6,2.4C574.5,275.3,585.9,298.1,594.6,315.4" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M627.7,414.5l2.6,5c0,0,1.3,2.8-1.6,2.2c-2.9-0.6-5.3-2.8-6-4.3s-7.7-15.1-7.7-15.1l-0.4-3.6l14.1-7.1
					l2.7,1.9l7.8,16.1c0,0,1.5,2.2,0.3,5c-1.2,2.8-1.6,3.2-1.6,3.2s-1,0.1-1.9-1.7c-0.9-1.8-2.8-5.2-2.8-5.2s-1.9-2.5-4.2-1.1
					C626.5,411.3,627.7,414.5,627.7,414.5z" />
                <g>
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M266.7,445.5c-13.8,40.7-52.4,70-97.7,70c-57,0-103.2-46.2-103.2-103.2s46.2-103.2,103.2-103.2
						c33.5,0,63.2,16,82.1,40.7" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M257.2,358.8c5.2,8.5,9.2,17.8,11.7,27.8" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M287.6,446.9c-15,51.4-62.4,89-118.7,89c-68.3,0-123.6-55.3-123.6-123.6s55.3-123.6,123.6-123.6
						c41.2,0,77.1,19.1,99.5,50.2" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M275.8,350.1c6.7,11.2,11.4,23.2,14.1,36.1" />
                </g>
                <g>
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M595.4,315.5c11.5-4.4,22.6-6.3,35.7-6.3c57,0,103.2,46.2,103.2,103.2s-46.2,103.2-103.2,103.2
						s-103.2-46.2-103.2-103.2c0-35.5,18-66.9,45.3-85.4" />
                    <path
                        class="fill-none stroke-woom-black stroke-2"
                        d="M586,296.7c14.1-5.6,29-7.9,45-7.9c68.3,0,123.6,55.3,123.6,123.6s-55.3,123.6-123.6,123.6
						s-123.6-55.3-123.6-123.6c0-43.7,21.8-81.9,56.1-103.9" />
                </g>
                <rect
                    x="373.3"
                    y="455.9"
                    class="fill-none stroke-woom-black stroke-2"
                    width="56.9"
                    height="12.8" />
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="331.6,380.6 308.1,380.6 288.8,380.6" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="284.4"
                    y1="367.8"
                    x2="326.5"
                    y2="367.8" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="312.1"
                    y1="385.1"
                    x2="308.1"
                    y2="380.6" />
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="357.7"
                    cy="418.6"
                    r="6.3" />
                <polygon
                    class="fill-none stroke-woom-black stroke-2"
                    points="513.1,193.6 509.6,186.2 532.4,176.7 539.3,180.7 540.3,183.1" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M453.4,336.6l-1,0.8c-0.2,0.1-0.4,0.2-0.8,0l-7-4.6c-2.3-1.5-5.2-1.8-7.7,0.2c-1.2,1-2,2.4-2.3,4
					c-1.8-0.1-3.5,0.6-4.5,1.4c-2.6,2-3.4,4.9-2.2,7.4c-2.7-1.2-6-0.8-8.5,1.1c-2.4,1.9-3.4,4.8-3,7.7c-2.7-1-5.8-0.7-8.2,1.2
					c-2.4,1.9-3.4,4.8-3,7.7l-1.3-1.6c-0.7-0.9-2-1-2.8-0.3c-0.9,0.7-1,2-0.3,2.8l5.4,6.8c0.8,1,0.4,2.5-0.5,3.3
					c-0.9,0.7-2.5,0.8-3.3-0.3l-0.1-0.1l-5.3-6.7c-0.7-0.9-2-1-2.8-0.4c-0.9,0.7-1,2-0.3,2.8l5.3,6.7l0.1,0.1c0.9,1.1,0.4,2.5-0.4,3.2
					c-0.8,0.6-1.8,0.8-3-0.1l-7.5-4.9c-1.8-1.2-3.5-0.4-4.2,0.1l-1.7,1.3c-0.9,0.7-1.1,1.9-0.4,2.8c0.7,0.9,1.9,1,2.8,0.3l1-0.8
					c0.2-0.1,0.4-0.2,0.8,0l7,4.6c2.3,1.5,5.2,1.8,7.7-0.2c1.2-1,2-2.4,2.3-4c1.8,0.1,3.5-0.6,4.5-1.4c2.6-2,3.4-4.9,2.2-7.4
					c2.7,1.2,6,0.8,8.5-1.1c2.4-1.9,3.4-4.8,3-7.7c2.7,1,5.8,0.7,8.2-1.2c2.4-1.9,3.4-4.8,3-7.7l1.3,1.6c0.7,0.9,2,1,2.8,0.3
					c0.9-0.7,1-2,0.3-2.8l-5.4-6.8c-0.8-1-0.4-2.5,0.5-3.3c0.9-0.7,2.5-0.8,3.3,0.3l0.1,0.1l5.3,6.7c0.7,0.9,2,1,2.8,0.4
					c0.9-0.7,1-2,0.3-2.8l-5.3-6.7l-0.1-0.1c-0.9-1.1-0.4-2.5,0.4-3.2c0.8-0.6,1.8-0.8,3,0.1l7.5,4.9c1.8,1.2,3.5,0.4,4.2-0.1l1.7-1.3
					c0.9-0.7,1.1-1.9,0.4-2.8C455.5,336,454.3,335.9,453.4,336.6z M416.4,365.9c-1.9,1.5-4.6,1.2-6.2-0.7c-1.5-1.9-1.2-4.7,0.7-6.2
					c1.9-1.5,4.7-1.2,6.2,0.7C418.6,361.6,418.3,364.4,416.4,365.9z M427.6,357c-1.9,1.5-4.6,1.2-6.2-0.7c-1.5-1.9-1.2-4.7,0.7-6.2
					c1.9-1.5,4.7-1.2,6.2,0.7C429.8,352.7,429.5,355.5,427.6,357z" />
            </g>
        </g>
        <g class="saddle-normal">
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="300.4"
                y1="257.9"
                x2="288.4"
                y2="228.3" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="276"
                y1="234"
                x2="287.3"
                y2="262.6" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M272.6,230.7l1.1,3.5l1,0c0,0,5.6-3.6,7.8-4.3c2.2-0.8,6.8-2.1,7.8-2c0.9,0.1,1.2-0.7,1.2-0.7l-1.2-2.8" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M229.1,216.3c0,0,21.8,9.9,30.2,12s11.2,2.6,15.3,1.2s23-9.4,29.8-12.2c6.8-2.8,25.2-5.9,32-6.6
				c6.8-0.7,8.2-1.2,7.8-5.3c-0.4-4.2-1-12.4-14.4-12.7c-13.5-0.3-12.8,1.5-25.6,1.6c-12.9,0.1-61.2-1.6-67-1.9
				c-5.8-0.3-12,0.5-12.8,5.5c-0.8,5-2.1,13.1,0,14.8C226.5,214.6,229.1,216.3,229.1,216.3z" />
        </g>
        <g class="handlebar-normal">
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M541.4,150.3l1.4,1.2l0.9-1.3l3.5,0.8l0.9,3.4l-1.7,10.4l-7.2,1.8c0,0-4.4,1.9-6.2,4.6s-0.9,4.8-0.9,4.8
				l-22.6,10.2l-6.1-14.9l1.5-5.8l20.5-15.6" />
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M523.3,90.5c0,0,1.3,5.8,1.5,16.9c0.2,11.1,0.8,49.5,0.8,49.5s0.6,8.9,8.3,8.3c7.7-0.6,7.5-8.3,7.3-11.3
					c0,0-1.3-28-1.4-29.2s-1.5-30.4-2.8-34.8s-2.9-9.6-4-11" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M518.9,68.3c0.9-0.2,1.8-0.3,2.8-0.3c6.1,0,11.1,5,11.1,11.1s-5,11.1-11.1,11.1c-1,0-1.5-0.2-2.4-0.5" />
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="508.6"
                    cy="79"
                    r="14.9" />
            </g>
        </g>
        <g class="tyres hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="170.1"
                                y1="288.7"
                                x2="170.1"
                                y2="535.9" />
                            <g>
                                <rect
                                    x="162.3"
                                    y="287.5"
                                    class="fill-woom-red stroke-woom-red"
                                    width="15.6"
                                    height="2.4" />
                            </g>
                            <g>
                                <rect
                                    x="162.3"
                                    y="534.7"
                                    class="fill-woom-red stroke-woom-red"
                                    width="15.6"
                                    height="2.4" />
                            </g>
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="631.2"
                                y1="288.7"
                                x2="631.2"
                                y2="535.9" />
                            <g>
                                <rect
                                    x="623.4"
                                    y="287.5"
                                    class="fill-woom-red stroke-woom-red"
                                    width="15.6"
                                    height="2.4" />
                            </g>
                            <g>
                                <rect
                                    x="623.4"
                                    y="534.7"
                                    class="fill-woom-red stroke-woom-red"
                                    width="15.6"
                                    height="2.4" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="cockpit hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="508.6"
                                y1="79.1"
                                x2="508.6"
                                y2="535.9" />
                            <g>
                                <rect
                                    x="500.8"
                                    y="77.9"
                                    class="fill-woom-red stroke-woom-red"
                                    width="15.6"
                                    height="2.4" />
                            </g>
                            <g>
                                <rect
                                    x="500.8"
                                    y="534.7"
                                    class="fill-woom-red stroke-woom-red"
                                    width="15.6"
                                    height="2.4" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="steering-angle hidden">
            <g class="inline">
                <g>
                    <g>
                        <polyline
                            class="h-line-miter fill-none stroke-woom-red stroke-3"
                            points="495.8,129.1 554.8,255.2 429.7,255.2" />
                    </g>
                    <path
                        class="h-line-miter fill-none stroke-woom-red stroke-3"
                        d="M505.9,254.9c0-19.5,11.6-36.4,28.2-44" />
                </g>
                <g>
                    <g>
                        <g>
                            <g>
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="557.3"
                                    y1="261.6"
                                    x2="559"
                                    y2="265.2" />
                                <line
                                    class="h-dash-line fill-none stroke-woom-red stroke-3"
                                    x1="562.5"
                                    y1="272.5"
                                    x2="686.9"
                                    y2="528.6" />
                                <polyline
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    points="688.7,532.2 690.4,535.8 686.4,535.8" />
                                <line
                                    class="h-dash-line fill-none stroke-woom-red stroke-3"
                                    x1="678.2"
                                    y1="535.8"
                                    x2="567.4"
                                    y2="535.8" />
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="563.3"
                                    y1="535.8"
                                    x2="559.3"
                                    y2="535.8" />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                class="h-line fill-none stroke-woom-red stroke-3"
                                d="M634.9,535.9c0-1.3,0.1-2.7,0.2-4" />
                            <path
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                d="M636.7,522.6c3.1-10.8,9.8-20.1,18.8-26.4" />
                            <path
                                class="h-line fill-none stroke-woom-red stroke-3"
                                d="M659.6,493.8c1.2-0.7,2.3-1.3,3.6-1.8" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="top-tube-horizontal hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="518.6"
                                y1="170"
                                x2="282"
                                y2="170" />
                            <g>
                                <rect
                                    x="517.4"
                                    y="162.2"
                                    class="fill-woom-red stroke-woom-red"
                                    width="2.4"
                                    height="15.6" />
                            </g>
                            <g>
                                <rect
                                    x="280.8"
                                    y="162.2"
                                    class="fill-woom-red stroke-woom-red"
                                    width="2.4"
                                    height="15.6" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="wheelbase hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="631.4"
                                y1="414"
                                x2="171.2"
                                y2="414" />
                            <g>
                                <rect
                                    x="630.2"
                                    y="406.3"
                                    class="fill-woom-red stroke-woom-red"
                                    width="2.4"
                                    height="15.5" />
                            </g>
                            <g>
                                <rect
                                    x="170"
                                    y="406.3"
                                    class="fill-woom-red stroke-woom-red"
                                    width="2.4"
                                    height="15.5" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="seat-tube-angle hidden">
            <g class="inline">
                <g>
                    <polyline
                        class="h-line-miter fill-none stroke-woom-red stroke-3"
                        points="298,270.2 404.3,535.9 174,535.9" />
                </g>
                <path
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    d="M353.3,534.8c0-22.2,12.2-39.6,31.1-48.3" />
            </g>
        </g>
        <g class="min-saddle-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <g>
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="301"
                                    y1="214.1"
                                    x2="296.8"
                                    y2="214.1" />
                                <line
                                    class="h-dash-line fill-none stroke-woom-red stroke-3"
                                    x1="288.1"
                                    y1="214.1"
                                    x2="31.7"
                                    y2="214.1" />
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="27.4"
                                    y1="214.1"
                                    x2="23.1"
                                    y2="214.1" />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <g>
                                    <line
                                        class="h-line fill-none stroke-woom-red stroke-3"
                                        x1="10"
                                        y1="214.1"
                                        x2="10"
                                        y2="535.9" />
                                    <g>
                                        <rect
                                            x="2.2"
                                            y="212.9"
                                            class="fill-woom-red stroke-woom-red"
                                            width="15.6"
                                            height="2.4" />
                                    </g>
                                    <g>
                                        <rect
                                            x="2.2"
                                            y="534.7"
                                            class="fill-woom-red stroke-woom-red"
                                            width="15.6"
                                            height="2.4" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="300.4"
                    y1="257.9"
                    x2="296.4"
                    y2="248.3" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="284"
                    y1="254"
                    x2="287.3"
                    y2="262.6" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M280.6,250.7l1.1,3.5l1,0c0,0,5.6-3.6,7.8-4.3c2.2-0.8,6.8-2.1,7.8-2c0.9,0.1,1.2-0.7,1.2-0.7l-1.2-2.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M237.1,236.3c0,0,21.8,9.9,30.2,12s11.2,2.6,15.3,1.2s23-9.4,29.8-12.2c6.8-2.8,25.2-5.9,32-6.6
					c6.8-0.7,8.2-1.2,7.8-5.3c-0.4-4.2-1-12.4-14.4-12.7c-13.5-0.3-12.8,1.5-25.6,1.6c-12.9,0.1-61.2-1.6-67-1.9
					c-5.8-0.3-12,0.5-12.8,5.5c-0.8,5-2.1,13.1,0,14.8C234.5,234.6,237.1,236.3,237.1,236.3z" />
            </g>
        </g>
        <g class="max-saddle-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <g>
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="281"
                                    y1="173.8"
                                    x2="276.5"
                                    y2="173.8" />
                                <line
                                    class="h-dash-line fill-none stroke-woom-red stroke-3"
                                    x1="267.3"
                                    y1="173.8"
                                    x2="32.3"
                                    y2="173.8" />
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="27.6"
                                    y1="173.8"
                                    x2="23.1"
                                    y2="173.8" />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <g>
                                    <line
                                        class="h-line fill-none stroke-woom-red stroke-3"
                                        x1="10"
                                        y1="173.8"
                                        x2="10"
                                        y2="535.9" />
                                    <g>
                                        <rect
                                            x="2.2"
                                            y="172.6"
                                            class="fill-woom-red stroke-woom-red"
                                            width="15.6"
                                            height="2.4" />
                                    </g>
                                    <g>
                                        <rect
                                            x="2.2"
                                            y="534.7"
                                            class="fill-woom-red stroke-woom-red"
                                            width="15.6"
                                            height="2.4" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="300.4"
                    y1="257.9"
                    x2="280.4"
                    y2="207.3" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="268"
                    y1="213"
                    x2="287.3"
                    y2="262.6" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M264.6,209.7l1.1,3.5l1,0c0,0,5.6-3.6,7.8-4.3c2.2-0.8,6.8-2.1,7.8-2c0.9,0.1,1.2-0.7,1.2-0.7l-1.2-2.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M221.1,195.3c0,0,21.8,9.9,30.2,12s11.2,2.6,15.3,1.2s23-9.4,29.8-12.2c6.8-2.8,25.2-5.9,32-6.6
					c6.8-0.7,8.2-1.2,7.8-5.3c-0.4-4.2-1-12.4-14.4-12.7c-13.5-0.3-12.8,1.5-25.6,1.6c-12.9,0.1-61.2-1.6-67-1.9
					c-5.8-0.3-12,0.5-12.8,5.5c-0.8,5-2.1,13.1,0,14.8C218.5,193.6,221.1,195.3,221.1,195.3z" />
            </g>
        </g>
        <g class="crank-length hidden">
            <g class="inline">
                <g>
                    <line
                        class="h-line-miter fill-none stroke-woom-red stroke-3"
                        x1="357.8"
                        y1="418.2"
                        x2="403.9"
                        y2="463.4" />
                    <g>
                        <polygon
                            class="fill-woom-red stroke-woom-red"
                            points="351.8,422.7 362.1,412.2 363.7,413.8 353.4,424.3" />
                    </g>
                    <g>
                        <polygon
                            class="fill-woom-red stroke-woom-red"
                            points="398,467.9 408.3,457.4 409.9,459 399.6,469.5" />
                    </g>
                </g>
            </g>
        </g>
        <g class="handlebar-adjustability hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <g>
                                <path
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    d="M534,25.1c23.4,2.1,42,20.7,44.1,44.1" />
                                <g>
                                    <polygon
                                        class="fill-woom-red stroke-woom-red"
                                        points="535.2,31.2 525.4,24.4 536.3,19.3" />
                                </g>
                                <g>
                                    <polygon
                                        class="fill-woom-red stroke-woom-red"
                                        points="572,68 578.9,77.8 583.9,66.9" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M539.2,149.7l3.6,1.9l0.9-1.3l3.5,0.8l0.9,3.4l-1.7,10.4l-7.2,1.8c0,0-4.4,1.9-6.2,4.6s-0.9,4.8-0.9,4.8
				l-22.6,10.2l-6.1-14.9l1.5-5.8l18.1-13.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M498.5,99.6c0,0,3.5,4.8,8,14.9s20.2,45.2,20.2,45.2s4.1,8,10.9,4.4s3.7-10.6,2.2-13.2
					c0,0-12.2-25.2-12.7-26.3c-0.6-1.1-13.3-27.4-16.2-30.9s-6.4-7.7-8-8.5" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M485.7,80.9c0.7-0.6,1.5-1,2.4-1.4c5.7-2.4,12.2,0.2,14.6,5.9s-0.2,12.2-5.9,14.6c-1,0.4-1.4,0.4-2.4,0.5" />
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="480.3"
                    cy="94.8"
                    r="14.9" />
            </g>
        </g>
        <g class="stand-over-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <g>
                                <g>
                                    <line
                                        class="h-line fill-none stroke-woom-red stroke-3"
                                        x1="12"
                                        y1="257.4"
                                        x2="12"
                                        y2="535.9" />
                                    <g>
                                        <rect
                                            x="4.2"
                                            y="256.2"
                                            class="fill-woom-red stroke-woom-red"
                                            width="15.6"
                                            height="2.4" />
                                    </g>
                                    <g>
                                        <rect
                                            x="4.2"
                                            y="534.7"
                                            class="fill-woom-red stroke-woom-red"
                                            width="15.6"
                                            height="2.4" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <g>
                                <line
                                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                                    x1="407.5"
                                    y1="257.3"
                                    x2="402.8"
                                    y2="257.3" />
                                <line
                                    class="h-dash-line fill-none stroke-woom-red stroke-3"
                                    x1="393.2"
                                    y1="257.3"
                                    x2="34.4"
                                    y2="257.3" />
                                <line
                                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                                    x1="29.6"
                                    y1="257.3"
                                    x2="24.9"
                                    y2="257.3" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>
